import * as _ from 'lodash';
import React from "react";
import {getStore} from '../store';
import md5 from 'js-md5';
import sha256 from 'js-sha256';

export function isMonumentCineraire(monument) {
  return ['900-999', 'CIN'].indexOf(monument.category) >= 0;
}
export function isMonumentDouble(monument) {
  return ['700-799'].indexOf(monument.category) >= 0;
}

export function isMonumentTombale(monument) {
  return monument.kind === 'TBL' || monument.category === 'TBL';
}
export function invalidVisual(monument) {
  const ref = monument.productId.slice(0,-3)
  const reforiginal = monument.productIdOriginal.slice(0,-3)
  if (ref !== reforiginal && !monument.ismonumentspec) {
    return true
  }
  return false
}
function shuffle(tab) {
  tab.sort(function (a, b) {
    return Math.random() - Math.random()
  })
}

export function sortLayouts(layouts) {
  return layouts.sort((x, y) => {
    // on trie par largeur puis par longueur
    const measureX = x.name.split("×");
    const measureY = y.name.split("×");
    if (measureX.length !== 2 || measureY.length !== 2) return 0;

    const diff = parseInt(measureX[0], 10) - parseInt(measureY[0], 10);
    if (diff !== 0) return diff;

    return parseInt(measureX[1], 10) - parseInt(measureY[1], 10);
  });
}

export function formatEmail(email) {
  const cleanEmail = email.toLowerCase().trim();
  
  return {
    clean: cleanEmail,
    md5: md5(cleanEmail),
    sha256: sha256(cleanEmail)
  };
}

export function formatToE164(countryCode, phoneNumber, foreignTown) {
  let phone = phoneNumber;
  phone = phone.replace(/^0+/, '');

  phone = `${countryCode}${phone.replace(/\D/g, '')}`;
  return phone;
};

function arrayRand(tableau, nb = null) {
  if (nb === null) nb = tableau.length
  /* Création du tableau temporaire de travail */
  let tmp = []
  tableau.forEach(function (e) {
    tmp.push(e)
  })
  /* Mélange */
  shuffle(tmp)
  /* Retour du 1er élément ou d'une tranche */
  if (nb === 1) {
    return tmp[0]
  } else {
    return tmp.slice(0, nb)
  }
}
export function defaultBicolorGranites(availableGranites, matchcolors) {
  let graniteslist = []
  const graniteslimit = 75
  const matchcolorsRandom = arrayRand(matchcolors)
  if (availableGranites.length <= graniteslimit) return availableGranites
  while(graniteslist.length < graniteslimit) {
    const graniteslistRef = graniteslist.map(granite => `${granite?.reference}/${granite?.gs?.reference}`)
    const availableGranitesFiltred = availableGranites.filter(granite => !graniteslistRef.includes(`${granite?.reference}/${granite?.gs?.reference}`))
    matchcolorsRandom.forEach((color, index, array) => {
      if (graniteslist.length === graniteslimit) {
        return 
      }
      const granite = availableGranitesFiltred.find(availableGranite => {
        return availableGranite.colorGranite === color.name
      })
      // const granite = granites[0]
      if(granite) {
        graniteslist.push(granite)
      }
    })
  }
  return graniteslist
}

export function convertDate (dateSelection) {
  let date = new Date(dateSelection);
  const leadZero = date.getMinutes()<10?'0':'' ;
  return (
    date.getDate() + "/" +
    (date.getMonth() + 1) +
    "/" +
    date.getFullYear() +
    " " +
    date.getHours() +
    ":" + leadZero +
    date.getMinutes()
  );
};
export function checkToken(error,parent=false){
  if (error && error.includes("TokenExpiredError")){
    // On recharge la page si le jeton a expiré
    if (parent){
       window.parent.location = document.referrer;
    }else{
       window.location.reload();
    }
   }
}
export function getDescription(monument,granites = null){
  // Pour les granits secondaires si la description est absente on affiche une phrase de description
  const {description,graniteSecondary} = monument;
  let newDescription ="";
  if (graniteSecondary.reference && !description){
    newDescription = "Granit Secondaire " + graniteSecondary.name;
  }  else if (description){newDescription = description}

  return newDescription;
}

export function getClientIdFromFamilyUrl (fullClientId) {
  return fullClientId.split('_')[0];
}

export function isGpgFamily(){
  return false; // on désactive en attendant d'être sûr du déploiement

}

export function getMonumentCategory() {
  return getStore().getState().catalog.monumentCategory;
}
export function isGpgpFamilyConfig(client){
  const infos = window.location.pathname.split('/');
  if (infos.length >2 && infos[1] === "famille"){
    const clientId = client ? client : getClientIdFromFamilyUrl(infos[2]);
    // if (clientId && clientId ==="CA102194"){
    if (clientId && getStore().getState().user.isGpgClient ){
      return true;
    }
  }
  return false
}
export const getFamilyClientId = () => {
  const elements =window.location.pathname.split('/');
  if(elements.length >=3 && elements[1]==="famille"){
      return elements[2];
    }
  return false
}
export const checkDisplaySimpleConfig=(config) => config.configType === "catalog"

/**
 * designType: A old configurator version / B testing configurator version
 */
export function getDesignTypeConfiguration (config = false) {
 /*  const designType = (config && config.designType) ? config.designType : localStorage.getItem("gpg-configuration-type");

  if (designType && (designType === "A" || designType === "B")) {
    return designType;
  } else {
    const newdesignType = ((Math.floor(Math.random()*2)%2) === 0) ? "A" : "B";
    localStorage.setItem('gpg-configuration-type', newdesignType);
    return newdesignType;
  } */
  return "B";
};

export function getVeneerDefaultData (veneerDefault) {
  let defaultVeneerData;

  if (veneerDefault?.defaultVeneerOraganization) {
    defaultVeneerData = JSON.parse(veneerDefault.defaultVeneerOraganization);
  } else if (veneerDefault?.defaultParamVeneer) {
    defaultVeneerData = JSON.parse(veneerDefault.defaultParamVeneer);
  }

  return defaultVeneerData;
}

export const isConfigurationRequested = (configuration) => (configurationQuoteRequested(configuration) || configurationOrdered(configuration))

export const configurationQuoteRequested = (configuration) => (configuration && configuration.status && configuration.status.completedAt);

export const configurationOrdered = (configuration) => ((configuration && configuration.status && configuration.status.validatedAt)||
                                                        (configuration && configuration.status && configuration.status.prevalidatedAt));

export const displayPackage = (user) =>  _.get(user,"identity.organization.displayPackagePrice");

export const pricePackageToDisplay = (user,price)=> {

  const pricePackageMonument = displayPackage(user) && price && price.selling > price.sellingWithoutPackage ?
                                 price.selling - price.sellingWithoutPackage : 0;
  return pricePackageMonument
 }

 export const totalPricePackageToDisplay = (user,config)=> {
   // On additionne le monument + la semelle et le placage , on ne peut pas utiliser le total car en cas de prix à 0
   // le calcul est mauvais
  return pricePackageToDisplay(user,config.monument.price) + pricePackageToDisplay(user,config.frame && config.frame.price)
         + pricePackageToDisplay(user,config.veneer && config.veneer.price);
 }

 export const packageInfoFamily = (user,config,notFamily = false, from) =>{
  const packagePrice = totalPricePackageToDisplay(user,config);
  if(notFamily) return ('');
  if (from === 'FbigDetail'){
    if (packagePrice){
      // return (`Les frais de pose sont estimés à ${packagePrice} €`);
      return (<>
        <p><span>Les frais de poses sont estimés à {packagePrice} € </span> mais sont amenés à être modifiés en fonction de la surface au sol du lieu de pose.</p>
      </>)
    } else{
      //return ("Devis à valider avec votre marbrier conseil")
      return (
        <>
          <p><span>Ce prix n'inclut pas les frais de pose</span> qui seront calculés avec votre marbrier conseil.</p>
        </>
      )
    }
  } else {
    return ('* Prix indicatif à valider avec votre marbrier')
  }
 }

export function getReactAppExtranet(path = "") {
  return `${process.env.REACT_APP_EXTRANET || 'http://localhost:3040'}${path}`;
}
export const getReactAppFamily = () => process.env.REACT_APP_FAMILY || 'http://localhost:3011';

export const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export const isStandardClient = (clientId) => clientId.startsWith("CA") && !(clientId.endsWith("-SF") || clientId.includes("-SF-"))

export const isFamilySpaceOn = (user)=> user && user.identity && user.identity.organization && user.identity.organization.familySpace ===1;

export const validUrl = (str) => {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

export const hexToRgb = hex => hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,(m, r, g, b) => '#' + r + r + g + g + b + b)
                .substring(1).match(/.{2}/g)
                .map(x => parseInt(x, 16))

export const replaceMultiplicationSymbol = (string = "") => {
  return string.replace(/[×x]/g, ' X ');
}

// Initialize icons for checkbox
export const initializeIconColor = (showSellingPrices) =>{
  const status = !showSellingPrices;
  const root = document.documentElement;
  const color = (status === true) 
    ? getComputedStyle(root).getPropertyValue("--secondary2")
    : getComputedStyle(root).getPropertyValue("--secondary2-hover") 
  const encodedColor = encodeURIComponent(color.trim());
  const styleTag = document.createElement("style");
  styleTag.textContent = `
    :root {
      --checked-euro-icon: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.594 8.482L1.062 7.366H9.018L8.55 8.482H0.594ZM9.612 5.242L9.162 6.358H0.936L1.404 5.242H9.612ZM2.232 6.52C2.232 5.74 2.37 4.978 2.646 4.234C2.922 3.478 3.324 2.794 3.852 2.182C4.38 1.558 5.028 1.066 5.796 0.705999C6.564 0.333999 7.434 0.147999 8.406 0.147999C9.57 0.147999 10.566 0.411999 11.394 0.94C12.234 1.456 12.858 2.122 13.266 2.938L11.682 4C11.454 3.484 11.154 3.076 10.782 2.776C10.422 2.476 10.026 2.266 9.594 2.146C9.162 2.026 8.742 1.966 8.334 1.966C7.674 1.966 7.086 2.104 6.57 2.38C6.066 2.644 5.64 2.998 5.292 3.442C4.956 3.886 4.704 4.384 4.536 4.936C4.368 5.488 4.284 6.04 4.284 6.592C4.284 7.204 4.386 7.798 4.59 8.374C4.794 8.938 5.076 9.442 5.436 9.886C5.808 10.318 6.24 10.66 6.732 10.912C7.236 11.164 7.788 11.29 8.388 11.29C8.808 11.29 9.234 11.218 9.666 11.074C10.11 10.93 10.518 10.708 10.89 10.408C11.274 10.096 11.58 9.688 11.808 9.184L13.482 10.138C13.218 10.774 12.804 11.314 12.24 11.758C11.688 12.202 11.064 12.538 10.368 12.766C9.672 12.994 8.988 13.108 8.316 13.108C7.428 13.108 6.612 12.922 5.868 12.55C5.124 12.166 4.482 11.662 3.942 11.038C3.402 10.402 2.982 9.694 2.682 8.914C2.382 8.122 2.232 7.324 2.232 6.52Z' fill='${encodedColor}'/%3E%3C/svg%3E%0A");
      --unchecked-euro-icon: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 19 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='euro-barred' clip-path='url(%23clip0_12936_83459)'%3E%3Cg id='Calque 1'%3E%3Cpath id='Vector' d='M2.6605 21.2081L4.02783 22L16.2338 0.792014L14.8665 9.93662e-05L2.6605 21.2081Z' fill='${encodedColor}'/%3E%3Cg id='Group'%3E%3Cpath id='Vector_2' d='M15.9752 2.48535L15.2075 3.81954C15.5775 4.05796 15.9286 4.34281 16.2551 4.67036C16.6658 5.08237 17.0256 5.58943 17.3257 6.17908L18.6206 5.39028C18.0387 4.21784 17.1623 3.24922 16.0143 2.50966C16.0016 2.50125 15.9886 2.49345 15.9755 2.48535H15.9752Z' fill='${encodedColor}'/%3E%3Cpath id='Vector_3' d='M13.1859 10.3554L13.5652 9.44629H11.969L11.4458 10.3554H13.1859Z' fill='${encodedColor}'/%3E%3Cpath id='Vector_4' d='M17.6539 15.6487C17.3525 16.2418 16.9822 16.7567 16.5516 17.1802C16.0958 17.6284 15.591 18.0092 15.051 18.3125C14.5111 18.6154 13.9453 18.8385 13.3687 18.9763C11.9104 19.3247 10.5142 19.2256 9.29048 18.7404C8.56753 18.4543 7.90082 18.0522 7.30743 17.5458L6.55249 18.8572C7.15893 19.3294 7.82813 19.7246 8.54983 20.0347C9.47564 20.4326 10.4909 20.6346 11.568 20.6346C12.2922 20.6346 13.041 20.5355 13.7934 20.3404C14.5443 20.1456 15.2666 19.8576 15.9399 19.4846C16.6119 19.1119 17.2301 18.649 17.7775 18.1086C18.2932 17.5997 18.704 17.0076 18.9997 16.3469L17.6539 15.6484V15.6487Z' fill='${encodedColor}'/%3E%3Cpath id='Vector_5' d='M3.01356 13.3003C3.26179 14.2786 3.64827 15.221 4.16243 16.1012C4.29882 16.3349 4.44391 16.5615 4.59676 16.7812L5.4592 15.2827C5.12491 14.685 4.86487 14.042 4.68499 13.3651C4.67474 13.3265 4.68282 13.2854 4.70705 13.2536C4.73128 13.2218 4.76887 13.2034 4.80864 13.2034H6.65592L7.1791 12.2943H4.56538C4.50356 12.2943 4.45043 12.25 4.43925 12.189C4.40228 11.9861 4.37866 11.7561 4.36966 11.5061C4.36065 11.2652 4.35599 10.9311 4.35599 10.4842C4.35599 10.4131 4.41346 10.3558 4.48429 10.3558H8.29504L8.81822 9.4467H4.61944C4.58154 9.4467 4.54581 9.42988 4.52127 9.40089C4.49703 9.37191 4.48647 9.33357 4.49299 9.29618C4.63839 8.45689 4.90619 7.63755 5.28832 6.86091C5.67139 6.08333 6.16629 5.38772 6.75906 4.79277C7.35339 4.19657 8.06235 3.71289 8.86607 3.35573C9.67196 2.99764 10.59 2.81594 11.5947 2.81594C11.9225 2.81594 12.2568 2.83932 12.5942 2.88513L13.3873 1.507C12.8551 1.41225 12.2931 1.36426 11.7028 1.36426C10.4291 1.36426 9.26839 1.58896 8.25279 2.03151C7.23564 2.47531 6.33903 3.07773 5.58813 3.82228C4.83629 4.56713 4.22177 5.42699 3.76135 6.37722C3.30062 7.32808 2.98591 8.32413 2.82653 9.33794C2.81659 9.40058 2.76284 9.44639 2.69977 9.44639H1.16286L0.783524 10.3555H2.59166C2.66249 10.3555 2.71997 10.4128 2.71997 10.4839C2.71997 10.9102 2.72432 11.2325 2.73333 11.469C2.74202 11.7078 2.76408 11.9346 2.79919 12.1444C2.8054 12.1818 2.79484 12.2198 2.77061 12.2488C2.74637 12.2778 2.71034 12.2943 2.67274 12.2943H0.379335L0 13.2034H2.8896C2.94831 13.2034 2.99926 13.2433 3.01387 13.3003H3.01356Z' fill='${encodedColor}'/%3E%3Cpath id='Vector_6' d='M12.1879 13.203L12.5881 12.2939H10.3301L9.80688 13.203H12.1879Z' fill='${encodedColor}'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_12936_83459'%3E%3Crect width='19' height='22' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    }
  `;
  document.head.appendChild(styleTag);
}